import React, { useEffect, useRef, useState } from "react"
import { Button } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import * as Yup from "yup"
import { useSubheader } from "../../../../../_metronic/layout/index.js"
import { TabsInputComponent } from "../../../../../component/index.jsx"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"
import { DataBase } from "./step/DataBase.jsx"
import { PreviewBase } from "./step/PreviewBase.jsx"
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers/index.js"
import { ILLUSTRATION_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import { loadUserLogin } from "../../../../../config/index.jsx"
import { BASE_DETAIL_TAB_STRING, BASE_STATUS_ENUM } from "../../../../../constants/StringConstant.js"
import { createMasterBase, updateMasterBase, getInitMasterBaseDetail } from "../../../../../redux/actions/MasterDataAction.jsx"
import { GENERAL } from "../../../../../constants/InitTypeConstants.js"
import ReactDOM from "react-dom"
import { stringFormatting } from "../../../../helpers/TextHelper.js"

export const MasterBaseCreateUpdate = ({
  history,
  match: { params: { id } }
}) => {
  const subHeader = useSubheader()
  const user = loadUserLogin()
  const formRef = useRef()
  const { General, MasterData } = useSelector((state) => state)
  const { t } = useTranslation()
  const [stepsTitle, setStepsTitle] = useState([t("label_data_base")])
  const [isSubmit] = useState(true)
  const [activeStep, setActiveStep] = useState(0)
  const [swalIcon, setSwallIcon] = useState("")
  const dispatch = useDispatch()
  const [initialData, setInitialData] = useState({
    id: "",
    type: "",
    baseProvince: "",
    baseRegency: "",
    baseDistrict: "",
    baseSubDistrict: "",
    basePostalCode: "",
    baseAddress: "",
    regionalId: user?.regional_id || "",
    sub_regional_id: "",
    useAvaliableWarehouse: null,
    warehouseId: "",
    latitude: 0,
    longitude: 0
  })

  useEffect(() => {
    return () => {
      subHeader.setButton(null)
    }
  }, [])

  useEffect(() => {
    if (!id) {
      if (!stepsTitle.includes(t("label_preview"))) {
        stepsTitle.push(t("label_preview"))
        setStepsTitle([...stepsTitle])
      }
    }
    subHeader.setBreadcrumbs(id ?
      [
        {
          title: t("menu_master_data"),
          pathname: RoutesConstants.MASTER_DATA.REGIONAL.PAGE()
        },
        {
          title: t("sub_header_base"),
          pathname: RoutesConstants.MASTER_DATA.BASE.LIST(BASE_STATUS_ENUM.ACTIVE)
        },
        {
          title: t("label_detail_base"),
          pathname: RoutesConstants.MASTER_DATA.BASE.DETAIL(id, BASE_DETAIL_TAB_STRING.DETAIL)
        },
        {
          title: t("sub_header_edit_base")
        }
      ] : [
        {
          title: t("menu_quick_access")
        },
        {
          title: t("sub_header_add_base")
        }
      ]
    )
    subHeader.setTitle(
      typeof id !== "undefined"
        ? t("sub_header_edit_base")
        : t("sub_header_add_base")
    )
  }, [id])

  useEffect(() => {
    if (id) {
      dispatch(getInitMasterBaseDetail(id))
    }
  }, [id, dispatch])

  useEffect(() => {
    const state = MasterData?.baseInitDetail

    if (state?.id && id) {
      let warehouseId = state.warehouse_id || ""
      if (warehouseId && warehouseId.includes(" - ")) {
        warehouseId = warehouseId.split(" - ")[1] || warehouseId
      }

      setInitialData({
        id: state.id || "",
        type: state.type_enum || "",
        baseProvince: state.province_id || "",
        baseRegency: state.regency_id || "",
        baseDistrict: state.district_id || "",
        baseSubDistrict: state.sub_district_id || "",
        basePostalCode: state.postal_code || "",
        baseAddress: state.full_address || "",
        regionalId: state.regional_id || user?.regional_id || "",
        sub_regional_id: state.sub_regional_id || "",
        useAvaliableWarehouse: state.warehouse_id ? "true" : "false",
        warehouseId: warehouseId,
        latitude: state.latitude ? parseFloat(state.latitude) : null,
        longitude: state.longitude ? parseFloat(state.longitude) : null
      })
    }
  }, [MasterData?.baseInitDetail, id])

  useEffect(() => {
    if (General.isFinishUpdateOrDelete && General?.actionInitType !== GENERAL.UPLOAD) {
      completeSubmit(id ? MasterData?.responseCreateBase : MasterData?.responseCreateBase?.message, MasterData?.responseCreateBase?.base_code, MasterData?.responseCreateBase?.warehouse_code, swalIcon)
    }
  }, [General.isFinishUpdateOrDelete])

  const completeSubmit = (message, baseCode, warehouseCode, icon) => {
    const content = document.createElement("div")

    ReactDOM.render(
      !id ? <div className={"d-flex flex-column align-items-center justify-content-center"} style={{ gap: 8 }}>
        <p style={{ textAlign: "center", color: "#333", fontSize: "14px" }}>
          {stringFormatting(message)}
        </p>

        <div style={{ textAlign: "center" }}>
          <div style={{ marginBottom: 8 }}>
            <span style={{ color: "#0e0c0cff", fontSize: "14px" }}>{t("label_base_name")} : </span>
            <span className="font-weight-bolder" style={{ color: "#000", fontSize: "14px" }}>{stringFormatting(baseCode) || "N/A"}</span>
          </div>
          <div>
            <span style={{ color: "#0e0c0cff", fontSize: "14px" }}>{t("label_odoo_warehouse_id_code")} : </span>
            <span className="font-weight-bolder" style={{ color: "#000", fontSize: "14px" }}>{stringFormatting(warehouseCode) || "N/A"}</span>
          </div>
        </div>
      </div> : <div className={"d-flex flex-column align-items-center justify-content-center"} style={{ gap: 8 }}>
        <p style={{ textAlign: "center", color: "#333" }}>
          {t("messages_response_success_edit_base")}
        </p>
      </div>
      , content)

    swal({
      content: {
        element: content
      },
      icon: icon,
      buttons: {
        list: {
          text: t("button_view_base_list"),
          value: "list",
          className: "swal-button--cancel font-weight-normal"
        },
        detail: !id && !MasterData?.responseCreateBase?.id ? false : {
          text: t("button_view_base_detail"),
          value: "detail",
          className: "swal-button--confirm font-weight-normal"
        }
      },
      closeOnClickOutside: false
    }).then((value) => {
      ReactDOM.unmountComponentAtNode(content)
      if (value === "list") {
        history.push(RoutesConstants.MASTER_DATA.BASE.LIST(BASE_STATUS_ENUM.ACTIVE))
      } else if (value === "detail") {
        if (id) {
          history.push(RoutesConstants.MASTER_DATA.BASE.DETAIL(id, BASE_DETAIL_TAB_STRING.DETAIL))
        } else {
          if (MasterData?.responseCreateBase?.id) {
            history.push(RoutesConstants.MASTER_DATA.BASE.DETAIL(MasterData?.responseCreateBase?.id, BASE_DETAIL_TAB_STRING.DETAIL))
          }
        }
      }
    })
  }

  useEffect(async () => {
    if (isSubmit) {
      if (window.location.href.includes("edit")) {
        subHeader.setButton(
          <Button
            variant="primary"
            onClick={() => {
              if (formRef.current) {
                formRef.current?.handleSubmit()
              }
            }}>
            {t("button_update")}
          </Button>
        )
      }
    }
  }, [isSubmit])

  useEffect(async () => {
    if (!id) {
      subHeader.setButton(
        <Button
          variant="primary"
          disabled={activeStep !== renderComponent().steps.length - 1}
          onClick={() => {
            if (formRef.current) {
              formRef.current?.handleSubmit()
            }
          }}>
          {t("button_submit")}
        </Button>
      )
    } else {
      if (window.location.href.includes("new")) {
        subHeader.setButton(false)
      }
    }
  }, [id, activeStep])

  const validationSchema = Yup.object().shape({
    type: Yup.string()
      .required(t("label_error_required", { label: t("label_base_type") })),
    sub_regional_id: Yup.string().required(t("label_error_required", { label: t("label_sub_regional") })),
    baseProvince: Yup.string().required(t("label_error_required", { label: t("label_province") })),
    baseRegency: Yup.string().required(t("label_error_required", { label: t("label_regency_city") })),
    baseDistrict: Yup.string().required(t("label_error_required", { label: t("label_district") })),
    baseSubDistrict: Yup.string().required(t("label_error_required", { label: t("label_sub_district") })),
    basePostalCode: Yup.string().required(t("label_error_required", { label: t("label_postal_code") })),
    baseAddress: Yup.string().required(t("label_error_required", { label: t("label_address") })),
    useAvaliableWarehouse: Yup.string().nullable().required(t("label_error_required", { label: t("label_assign_base_to_odoo_warehouse") })),
    warehouseId: Yup.string()
      .transform((value, originalValue) => {
        if (originalValue === "" || originalValue === null || originalValue === undefined) {
          return undefined
        }
        return value
      })
      .when("useAvaliableWarehouse", {
        is: "true",
        then: Yup.string().required(t("label_error_required", { label: t("label_odoo_warehouse") })),
      }),
    latitude: Yup.number()
      .transform((value, originalValue) => {
        if (originalValue === 0 || originalValue === "" || originalValue === null || originalValue === undefined) {
          return undefined
        }
        return value
      })
      .required(t("label_error_required", { label: t("label_pin_location") })),
    longitude: Yup.number()
      .transform((value, originalValue) => {
        if (originalValue === 0 || originalValue === "" || originalValue === null || originalValue === undefined) {
          return undefined
        }
        return value
      })
      .required(t("label_error_required", { label: t("label_pin_location") })),
  })

  const renderComponent = () => {
    const steps = [t("label_detail_base_information")]
    const stepsDescription = [t("label_base_information_detail"), t("label_review_and_submit")]
    const flow = [<DataBase key={0} isReadOnly={false} />]

    if (!id) {
      if (!steps.includes(t("label_preview"))) {
        steps.push(t("label_preview"))
        stepsDescription.push("Review & Submit")
        flow.push(<PreviewBase key={1} />)
      }
    }

    return {
      steps,
      stepsDescription,
      flow
    }
  }

  const onSubmit = async ({ submited, values }) => {
    if (submited) {
      const payload = {
        sub_regional_id: values?.sub_regional_id,
        type_enum: values?.type,
        latitude: values?.latitude?.toString(),
        longitude: values?.longitude?.toString(),
        province_id: values?.baseProvince,
        regency_id: values?.baseRegency,
        district_id: values?.baseDistrict,
        sub_district_id: values?.baseSubDistrict,
        full_address: values?.baseAddress,
        postal_code: values?.basePostalCode,
        use_available_warehouse: values?.useAvaliableWarehouse === "true",
        warehouse_id: values?.useAvaliableWarehouse === "true" ? values?.warehouseId : null
      }

      if (id) {
        payload.id = id
        setSwallIcon(toAbsoluteUrl(ILLUSTRATION_CONSTANTS.SUCCESS_EDIT_SCHEDULE))
        dispatch(updateMasterBase(payload))
      } else {
        setSwallIcon(toAbsoluteUrl(ILLUSTRATION_CONSTANTS.SUCCESS_EDIT_SCHEDULE))
        dispatch(createMasterBase(payload))
      }
    }
  }

  return (
    <>
      <TabsInputComponent
        key={initialData.id || 'new'}
        isEditTabs={[undefined, null, ""].indexOf(id) < 0}
        steps={renderComponent().steps}
        stepDescription={renderComponent().stepsDescription}
        innerRef={formRef}
        formInitialValues={initialData}
        formId="formBase"
        componentTab={renderComponent().flow}
        validationSchema={[validationSchema]}
        onSubmitForm={onSubmit}
        onChangeStep={(activeStep) => {
          setActiveStep(activeStep)
        }}
      />
    </>
  )
}